import React, {memo} from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { MDXProvider } from "@mdx-js/react";
import SystemContent from "../text/systems.mdx";

const Systems = () => {

  const components = {
      p: (() => {
        return memo(props =>
          <Typography {...props} component="p" variant="body1" style={{marginBottom: "20px"}}/>);
      })(),
      h5: (() => {
        return memo(props =>
          <div style={{textAlign: "center"}}>
            <Typography {...props} component="h5" variant="h5" style={{margin: "20px 0px 40px 0px"}}/>
          </div>
        );
      })(),
      h6: (() => {
        return memo(props =>
          <Typography {...props} component="h6" variant="h6" style={{margin: "30px 0px 20px 0px"}}/>);
      })(),
      a: (() => {
        return memo(props =>
          <Link {...props}/>);
      })(),
  };

  return (
    <div style={{maxWidth: "1300px", margin: "40px auto 0px auto", paddingBottom: "80px"}}>
      <MDXProvider components={components}>
        <SystemContent/>
      </MDXProvider>
    </div>
  );
};

export default Systems;